module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-bcstudy-api.rugcc.org/api/v1",
        current_environment : "bcstudy"
    }
};